module.exports = __webpack_public_path__ + "img/wt.0880625f.png";